module.exports = __webpack_public_path__ + "static/media/Pikipek_gaussian2.6666b899.png";